import React from "react";

export default class GalleryLink extends React.PureComponent {
  render() {
    return (
      <a
        href="https://www.google.com/maps/uv?pb=!1s0x80858776e1d989a7%3A0x5d2faf580126190d!3m1!7e115!4shttps%3A%2F%2Flh5.googleusercontent.com%2Fp%2FAF1QipPKpVmX8Jga4VAXu8QFUp6KJT5iIAkCTADg2FcS%3Dw86-h87-n-k-no!5sSign%20Awning%20-%20Google%20Search!15sCgIgAQ&imagekey=!1e10!2sAF1QipNS5v7GWvbgHArsHNDJwHvUPxPCpfxyw5acyb2c&hl=en"
        target="_blank"
        rel="noopener noreferrer"
        {...this.props}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/gallerylink.js